var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',_vm._g(_vm._b({attrs:{"active":_vm.internalActive},on:{"update:active":function($event){_vm.internalActive=$event}}},'vs-popup',_vm.$attrs,false),_vm.popupListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }